import React from "react";
import ClientsComboBox from "Components/Client/ClientsComboBox";

//MUI
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useAuth } from "Hooks/useAuth";
import { COUNTRYCODE } from "utils/options/COUNTRYCODE";
import { LANGUAGECODE } from "utils/options/LANGUAGECODE";
import { BOOLVALUEINT } from "utils/options/BOOLVALUEINT";

export default function EndcustomerFormGeneral({
  endcustomer,
  FORM_MODE,
  clients,
  handleInputChange,
}) {
  const { isAdmin } = useAuth();
  const boolOptions = BOOLVALUEINT;
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Id"
            label="ID"
            value={endcustomer.Id}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
            disabled
            sx={{ backgroundColor: "#f9f9f9" }}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            autoFocus={true}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            name="Name"
            label="Namn"
            value={endcustomer.Name}
            onChange={(e) => handleInputChange("Name", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="OrgNo"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Org.nr"
            value={endcustomer.OrgNo}
            onChange={(e) => handleInputChange("OrgNo", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Name2"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Namn2"
            value={endcustomer.Name2}
            onChange={(e) => handleInputChange("Name2", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Address"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Adress"
            value={endcustomer.Address}
            onChange={(e) => handleInputChange("Address", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Address2"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Adress2"
            value={endcustomer.Address2}
            onChange={(e) => handleInputChange("Address2", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="PostalCode"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Postnr"
            value={endcustomer.PostalCode}
            onChange={(e) => handleInputChange("PostalCode", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="City"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Postort"
            value={endcustomer.City}
            onChange={(e) => handleInputChange("City", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
            <InputLabel>Landkod</InputLabel>
            <Select
              value={endcustomer.CountryCode}
              disabled={FORM_MODE === "LOCKED" ? true : false}
              name="CountryCode"
              label="Landskod"
              size="small"
              onChange={(e) => handleInputChange("CountryCode", e.target.value)}
            >
              {COUNTRYCODE.map((country) => (
                <MenuItem key={country.Value} value={country.Value}>
                  {country.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
            <InputLabel>Språkkod</InputLabel>
            <Select
              value={endcustomer.LanguageCode}
              disabled={FORM_MODE === "LOCKED" ? true : false}
              name="LanguageCode"
              label="Landskod"
              size="small"
              onChange={(e) =>
                handleInputChange("LanguageCode", e.target.value)
              }
            >
              {LANGUAGECODE.map((language) => (
                <MenuItem key={language.Value} value={language.Value}>
                  {language.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="ExternalCustomerNr"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Externt kundnummer"
            value={endcustomer.ExternalCustomerNr}
            onChange={(e) =>
              handleInputChange("ExternalCustomerNr", e.target.value)
            }
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        {isAdmin ? (
          <Grid item xs={12} sm={6} md={4}>
            <ClientsComboBox
              label={"Klient"}
              disabled={
                FORM_MODE === "LOCKED" || FORM_MODE === "CLIENT_CREATE"
                  ? true
                  : false
              }
              clients={clients}
              selectedID={endcustomer.ClientId ? endcustomer.ClientId : null}
              onChange={(newVal) => handleInputChange("ClientId", newVal)}
            />
          </Grid>
        ) : null}
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="VATRegistration"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Momsregnummer"
            value={endcustomer.VATRegistration}
            onChange={(e) =>
              handleInputChange("VATRegistration", e.target.value)
            }
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        {isAdmin && (
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
              <InputLabel>Påminnelse/krav-stoppad</InputLabel>
              <Select
                disabled={FORM_MODE === "LOCKED" ? true : false}
                value={endcustomer.ReminderStop}
                onChange={(e) =>
                  handleInputChange("ReminderStop", e.target.value)
                }
                name="ReminderStop"
                label="Påminnelse/krav-stoppad"
                size="small"
              >
                {boolOptions.map((item) => (
                  <MenuItem key={item.Value} value={item.Value}>
                    {item.Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
      </Grid>
    </>
  );
}

/*
    ExternalCustomerNr: endcustomer.ExternalCustomerNr,
    ID: endcustomer.ID,
*/
